import apiFetch from '../../apiFetch'

export default function (token, dossierIdArray, approvalRoleCode) {
  return apiFetch({
    endPoint: `dossier/Service/SearcherMassiveApproveByRole?&approvalRoleCode=${approvalRoleCode}&servicesId=${dossierIdArray.join(',')}`,
    method: 'PUT',
    token: token
  })
}
